import React from 'react'
import { scaleDimensions, getHexColor } from '../utils'
import { OneColorLogoProps } from './LogoTypes'

export const CoxLogo: React.FC<OneColorLogoProps> = ({ height = 32, color = 'white', className }) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(height, 47, 18)
  const hex = getHexColor(color)

  return (
    <svg
      fill={hex}
      className={className}
      width={scaledWidth}
      height={scaledHeight}
      aria-label={'Cox Logo'}
      version="1.1"
      viewBox="0 0 314.05 96.028"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(319.7 -99.958)">
        <g strokeWidth=".29002">
          <path
            d="m-58.114 147.97 25.888-29.275c3.7102-4.1939 3.3135-10.603-0.8791-14.31-4.1926-3.7093-10.604-3.3148-14.312 0.87865l-24.229 27.402-24.228-27.402c-3.7102-4.194-10.116-4.5882-14.312-0.87865-4.1926 3.7093-4.5884 10.116-0.87908 14.31l25.885 29.275-25.888 29.275c-3.7102 4.1939-3.3135 10.603 0.8791 14.31 4.1926 3.7093 10.603 3.3149 14.312-0.87863l24.228-27.402 24.229 27.402c3.7102 4.1939 10.116 4.5882 14.312 0.87863 4.1926-3.7093 4.5879-10.116 0.8791-14.31z"
            fill={hex}
          />
          <path
            d="m-178.37 195.99c-26.474 0-48.014-21.537-48.014-48.014 0-26.477 21.54-48.014 48.014-48.014 26.473 0 48.014 21.537 48.014 48.014 0 26.477-21.54 48.014-48.014 48.014zm0-75.749c-15.293 0-27.735 12.442-27.735 27.735 0 15.292 12.442 27.735 27.735 27.735 15.292 0 27.735-12.442 27.735-27.735 0-15.293-12.442-27.735-27.735-27.735z"
            fill={hex}
          />
          <path
            d="m-271.69 195.99c-26.477 0-48.014-21.541-48.014-48.014 0-26.473 21.537-48.014 48.014-48.014 8.602 0 17.045 2.3055 24.417 6.6647 4.8201 2.851 6.4151 9.0691 3.5659 13.889-2.8491 4.8202-9.069 6.4154-13.889 3.5642-4.2467-2.5115-9.1214-3.84-14.092-3.84-15.293 0-27.735 12.442-27.735 27.735 0 15.293 12.442 27.735 27.735 27.735 4.9711 0 9.8462-1.3286 14.092-3.84 4.8201-2.851 11.038-1.256 13.889 3.5641 2.8492 4.8202 1.2578 11.038-3.5659 13.889-7.3726 4.3589-15.816 6.6648-24.417 6.6648z"
            fill={hex}
          />
        </g>
      </g>
    </svg>
  )
}
